export const BuyerGroupAction = {
  FETCH_BUYERGROUP: 'FETCH_BUYERGROUP',
  SHOW_BUYERGROUP: 'SHOW_BUYERGROUP',
  HIDE_BUYERGROUP: 'HIDE_BUYERGROUP',
  UPDATE_BUYERGROUP_ITEM: 'UPDATE_BUYERGROUP_ITEM',
  SAVE_BUYERGROUP: 'SAVE_BUYERGROUP',
  DEFAULT_BUYERGROUP: 'DEFAULT_BUYERGROUP',
  UPDATE_BUYERGROUP_LIST: 'UPDATE_BUYERGROUP_LIST',
  DELETE_BUYERGROUP: 'DELETE_BUYERGROUP',
  CLONE_BUYERGROUP: 'CLONE_BUYERGROUP',
  SPLITSCENARIO_BUYERGROUP: 'SPLITSCENARIO_BUYERGROUP',
  GET_CONTRACT_ID: 'GET_CONTRACT_ID',
  GET_COUNT: 'GET_COUNT',
  GET_LIST_COUNT: 'GET_LIST_COUNT',
  GET_SIGNUP_COLUMNS: 'GET_SIGNUP_COLUMNS'
};

export const BuyerGroupModalAction = {
  CREATE: 'MODAL_CREATE',
  EDIT: 'MODAL_EDIT',
  DELETE: 'MODAL_DELETE',
};

export const BuyerGroupURL = {
  REVIEW: 'api/BuyerGroup/Get',
  CREATE: 'api/BuyerGroup/Create',
  UPDATE: 'api/BuyerGroup/Update',
  DELETE: 'api/BuyerGroup/Delete',
  CHECK_DEFAULT: 'api/BuyerGroup/GetDefault',
  BUYERS: 'api/Buyer/get/ALL',
  TCPAS: 'api/Tcpa/Get',
  TYPAGES: 'api/BuyerGroup/ThankYouPages',
  SPLITSCENARIO: 'api/BuyerGroup/splitscenarios',
  CONTRACT: 'api/Buyer/GetContracts',
  COUNT: 'api/BuyerGroup/getCount',
  LISTCOUNT: 'api/BuyerGroup/GetListCount',
};
